import { TranslatableText, TranslatableTextVariantProps } from './TranslatableText'

export function Title1(props: TranslatableTextVariantProps) {
  return (
    <TranslatableText
      variant={'h1'}
      {...props}
      component={'h1'}
    />
  )
}
